export const GET_ADMINMAINTENANCEMODE_ABORTED =
  'GET_ADMINMAINTENANCEMODE_ABORTED';
export const GET_ADMINMAINTENANCEMODE_REQUESTED =
  'GET_ADMINMAINTENANCEMODE_REQUESTED';
export const GET_ADMINMAINTENANCEMODE_COMPLETED =
  'GET_ADMINMAINTENANCEMODE_COMPLETED';
export const GET_ADMINMAINTENANCEMODE_FAILED =
  'GET_ADMINMAINTENANCEMODE_FAILED';

export const SET_ADMINMAINTENANCEMODE_REQUESTED =
  'SET_ADMINMAINTENANCEMODE_REQUESTED';
export const SET_ADMINMAINTENANCEMODE_COMPLETED =
  'SET_ADMINMAINTENANCEMODE_COMPLETED';
export const SET_ADMINMAINTENANCEMODE_FAILED =
  'SET_ADMINMAINTENANCEMODE_FAILED';
